import React from "react";
import {
	Link
} from "react-router-dom";
export default class Declaration extends React.Component {


	render() {
		return (
			<div className="container my-3">
				<h1 className="text-center py-3  my-3">Brain Label 使用声明</h1>
				<p>
					Brain Label 一站式脑影像分析平台，为用户提供全球领先的神经影像处理、量化分析及三维重建服务。在使用Brain Label服务前请认真阅读以下许可条款。一旦使用本平台服务即视为您已同意所有条款和条件。感谢您的使用！
				</p>

				<h3>仅限学术和合法使用</h3>
				<p>Brain Label服务平台提供的所有程序、功能模块和分析内容仅供科研使用，分析结果不直接提供任何诊断或疾病相关信息，未经迈格生命科技（深圳）有限公司书面许可，禁止用于任何商业用途。如果您违反以上规定，迈格生命科技（深圳）有限公司将保留采取法律行动的权利。此外，您不得以任何直接或间接违反任何法律或所有权的方式使用本平台（包括中国以及其他国家的法律和所有权）。如果您对您的预期用途有任何疑问，或者您对本平台有任何评论或改进建议，请发送邮件至service@mindsgo.com与我们沟通。</p>
				 
				<h3>知识产权</h3>
				<p>迈格生命科技（深圳）有限公司拥有Brain Label平台的全部所有权，包括但不限于所有知识产权。</p>
				 
				<h3>免责声明</h3>
				<p>Brain Label 所提供的影像数据分析服务仅供科研使用，迈格生命科技（深圳）有限公司对使用本平台造成的任何风险不承担任何责任。请您理解并自行决定是否使用本平台功能并同意承担风险，并且对于因计算机系统的任何损坏或下载或使用程序的过程中导致的数据丢失承担全部责任。</p>
				 
				<h3>期限和终止</h3>
				<p>一旦您停止使用本平台，协议自动终止，同时您必须删除您从本网站获得的任何程序和文件。若发现用户违反使用条款，迈格生命科技（深圳）有限公司拥有账户的最终使用决定权及解释权。</p>
				 
				<p>使用本平台软件之前，请查阅使用声明。</p>
				<p>如有任何问题，请联系您的系统管理员或brainlabe支持团队。</p>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/site/sign/declaration.js